import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ViewChildren,
  QueryList,
  OnDestroy,
  ElementRef,
  Inject,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { FormControl, FormGroup } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { environment } from '../../../../environments/environment';
import { Session, getCurrentMenu, Shipping, AuthService } from '../../../core';
import { SnackbarService } from '../../../shared/components/snackbar/snackbar.service';
import { SCHEMAS } from './data-table.config';
import { DataTableExternal, Column, IconsOfActions, SortServerType } from './data-table-external.interface';
import { DataTableService } from './data-table.service';
import { DataTableColumnsComponent } from './data-table-columns/data-table-columns.component';
import { debounceTime } from 'rxjs/operators';
import { REAL_PLAZA_CODE } from '../../../core/configs/company.config';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  standalone: false,
  selector: 'app-data-table-external',
  templateUrl: './data-table-external.component.html',
  styleUrls: ['./data-table-external.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
    ])
  ]
})
export class DataTableExternalComponent implements OnInit, OnChanges, OnDestroy {
  @Input() visibleButton = true;
  @Input() type: string;
  @Input() id = '';
  @Input() typeZone: string;
  @Input() data: any[];
  @Input() expandableConfig;
  @Input() disabled: boolean;
  @Input() shippings: Shipping[] = [];
  @Input() typeEdition: string;
  @Input() size: 'small' | 'large' | 'xl' = 'small';
  @Input() expandedFather: any;
  @Input() defaultTable = true;
  @Input() currentConfigType: string;
  @Input() currentEntityType: string;
  @Input() currentEntityCode: string;
  @Input() currentEntityGroup: string;
  // despachos
  @Input() column: any;
  @Input() shippingType: string = null;
  @Output() filter = new EventEmitter<any>();
  @Output() update = new EventEmitter<any>();
  @Output() updateInline = new EventEmitter<any>();
  @Output() updateTable = new EventEmitter<any>();
  @Output() checkboxItem = new EventEmitter<any>();
  @Output() detail = new EventEmitter<any>();
  @Output() rowButtonClick = new EventEmitter<any>();
  @Output() closeDetail = new EventEmitter<boolean>();
  /**Evento que emite al dar click en el icono de la columna map, delete */
  @Output() onClickIconColumn = new EventEmitter();
  @Output() iconActionHeader = new EventEmitter<any>();
  @Output() showDialog = new EventEmitter<any>();
  @Output() isMark = new EventEmitter<any>();
  @Output() changeSelect = new EventEmitter<any>();
  @Output() changePage = new EventEmitter<any>();
  @Output() viewRecord = new EventEmitter<any>();
  @Output() actionButton = new EventEmitter<any>();
  @Output() actionIconRow = new EventEmitter<any>();
  @Output() dataSelected = new EventEmitter<any>();
  @Output() loadAllData = new EventEmitter<any>();
  @Output() loadAditionalAllData = new EventEmitter<any>();
  @Output() selectedItem = new EventEmitter<any>();
  @Output() changeSortServer = new EventEmitter<any>();
  @Output() valueSearchService = new EventEmitter<any>();
  @ViewChild('scroll') scroll;
  @ViewChildren(DataTableExternalComponent) children: QueryList<DataTableExternalComponent>;
  public selection = new SelectionModel<DataTableExternal>(true, []);
  private session: Session;
  dataTable: DataTableExternal;
  dataSource: MatTableDataSource<any>;
  displayedColumns: string[];
  dataSubTable: MatTableDataSource<any>;
  displayedColumnsSubTable: string[];
  listFilter: any;
  filterControl = new FormControl();
  searchControl = new FormControl();
  disabledSubTable = false;
  disabledButton = false;
  currentMenu = getCurrentMenu();
  dataSelect;
  valueFilter;
  checkAlls = {};
  showOtherHeader = false;
  actionHeader = [];
  headersColumns = [];
  expandedElement: any;
  form: FormGroup;
  itemValue = [];
  itemTableValue = [];
  dataInit = [];
  itemDisabled = [];
  checkedDialogCheck = false;
  resetCheck = true;
  paginatorValues: any = {};
  stopNextPaginator;

  @Input() hability = false;
  @Input() multiple = false;
  @Input() isAllSelect = null;
  @ViewChild('description') description: ElementRef;
  @ViewChild(MatSort) sort: MatSort;

  // Paginación con toda la data
  @ViewChild(MatPaginator) paginator: MatPaginator;

  /**
   * Creates an instance of data table component.
   * @param cdr: ChangeDetectorRef
   * @param dataTableService: DataTableService
   * @param snackbarService: SnackbarService
   * @param matDialog: MatDialog
   * @param document: Document
   * @param authService: AuthService
   */
  constructor(
    private cdr: ChangeDetectorRef,
    public dataTableService: DataTableService,
    public snackbarService: SnackbarService,
    public matDialog: MatDialog,
    private authService: AuthService,
    @Inject(DOCUMENT) public document
  ) { }


  /**
   * on changes
   */
  ngOnChanges() {
    // para despachos
    if (this.column) {
      this.dataTable.columns[this.column.ind].title = this.column.title;
    }
    this.dataSource = new MatTableDataSource(this.data);
    this.onChangeItemValue(this.disabled);
    // habilitar sort table
    if (this.dataTable && this.dataTable.sort) {
      this.dataSource.sort = this.sort;
      this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
    }

    this.dataSubTable = new MatTableDataSource(this.shippings);
    if (this.type === 'dispatchZone' && this.dataSource.filteredData.length) {
      if (this.typeZone !== this.type) {
        this.displayedColumns.splice(2, 0, this.dataTable.partialField);
        this.displayedColumns = Array.from(new Set(this.displayedColumns));
      } else {
        this.displayedColumns = this.displayedColumns.filter(item => item !== 'configuredZones');
      }
    }
    if (this.data) {
      this.resetValues();
    }
    this.filterPredicate();
    if (this.shippings.length) {
      setTimeout(() => {
        const id = document.getElementById('description');
        this.scrollTop(id);
      });
    }
    if (this.data && this.data.length && (this.type === 'inStorePicking' || this.type === 'returnManagement')) {
      const id = document.getElementById('dataTable');
      this.scrollTop(id);
    }
    this.session = JSON.parse(localStorage.getItem(environment.sessionAuth));
    if (this.type === 'inStorePickingDetail') {
      if (this.expandedFather) {
        const isValidEntity = (this.session.user.managingEntitiesPermissions && this.session.user.managingEntitiesPermissions.find(item => item == this.expandedFather.entityCode))
          || this.session.user.entities.find(item => item.entityCode.includes(this.expandedFather.entityCode));
        if (!isValidEntity) {
          this.showOtherHeader = false;
          this.dataTable.checkbox = false;
          this.displayedColumns = this.displayedColumns.filter(item => item !== 'select');
          this.selection.clear();
        } else {
          this.dataTable.checkbox = true;
          this.getIconHeader();
        }
      }
    } else if (this.dataTable && this.type === 'userExternalSetting') {
      this.dataTable.checkbox = true;
      this.getIconHeader();
    }
    if (this.type === 'reportDiscount'&& this.dataSource.filteredData.length) {
      this.dataTable.currency = this.session.user.currencyCode;
    }
    if (this.children !== undefined) {
      this.children.forEach(child => {
        child.itemValue = this.itemTableValue[child.id];
      });
    }
    this.enabledPaginator();
  }

  /**
   * on init
   */
  ngOnInit() {
    this.dataTable = this.getSchemaByType(this.type);
    this.displayedColumns = this.dataTable.columns
      .filter((column: any) => !column.onlyExport &&
        (column.visible || (!column.visible && !this.dataTable.alterColumns)))
      .map((column: any) => column.name);

    if (this.dataTable.checkbox) {
      this.getIconHeader();
    }

    if (this.dataTable.table) {
      this.displayedColumnsSubTable = this.dataTable.subTable.columns.map(
        (column: any) => column.name
      );
    }
    if (this.type === 'inStorePicking' || this.type === 'returnManagement') {
      this.dataTable.export = false;
    }
    this.listFilter = this.dataTableService.typeFilter(this.type);
    setTimeout(() => {
      if (this.dataTable.filter) {
        this.session = JSON.parse(localStorage.getItem(environment.sessionAuth));
        if (
          this.session &&
          this.session.table &&
          this.session.table[this.currentMenu.module] &&
          this.session.table[this.currentMenu.module].filter
        ) {
          this.filterControl.setValue(this.session.table[this.currentMenu.module].filter);
          this.filterRecords(this.session.table[this.currentMenu.module].filter);
        } else {
          this.filterControl.setValue(this.dataTable.filterDefault);
          this.filterRecords(this.dataTable.filterDefault);
        }
      }
    });
    /*
        this.searchControl.valueChanges
          .pipe(debounceTime(500))
          .subscribe(response => {
               if (response.length >= 3 && this.dataTable.searchTextService) {
                this.valueSearchService.emit(response);
              }
            }); */
    this.enabledPaginator();
  }

  assignDataTable(type) {
    this.dataTable = this.getSchemaByType(type);
  }

  enabledPaginator() {
    if (this.dataTable && this.dataTable.paginatorAllData) {
      this.dataSource.paginator = this.paginator;
      this.paginator._intl.firstPageLabel = 'Primera página';
      this.paginator._intl.lastPageLabel = 'Ultima página';
    }
  }
  /** Usan desde child */
  asignHability(hability: boolean) {
    this.hability = hability;
  }
  /** Usan desde child */
  onChangeColumnTitle(columnName: string, columnTitle: string, hability: boolean) {
    this.changeTitleValues(columnName, columnTitle);
    this.hability = hability;
  }

  changeTitleValues(columnName: string, columnTitle: string){
    const column = this.dataTable.columns.find(column => column.name === columnName);
    if(column){
      column.title =  columnTitle;
    }
  }

  onChangeSelect(event, indice) {
    this.changeSelect.emit({ selectChange: event, indice: indice });
  }

  onSelectedChecked(event: any) {
    this.selectedItem.emit(event);
  }

  onCheckedItems(data: any) {
    data.filter(row => !this.dataTable.hasDisabledCheckBoxItem(row)).forEach(row => {
      if (this.selection.isSelected(row)) {
        this.selection.deselect(row);
      } else {
        this.selection.select(row);
      }
    });
  }

  onChangeValue(value, indice) {
    this.itemValue[indice] = value;
  }

  onChangeMultipleTableValue(id, value, indice) {
    this.children.forEach(child => {
      if (child.id === id) {
        child.onChangeValue(value, indice);
      }
    });
  }

  onUpdateCheckboxEnabled(value: boolean) {
    this.checkedDialogCheck = value;
  }

  onUpdateCheckboxHeader(value) {
    this.dataTable.checkboxHeader = value;
  }

  onUpdateCheckboxRow(value) {
    this.dataTable.checkboxRow = value;
  }

  getIconHeader() {
    this.actionHeader = [];
    this.actionHeader.push({
      icon: 'actions',
      action: this.getSchemaByType(this.type) && this.getSchemaByType(this.type).iconsOfActions ? this.getSchemaByType(this.type).iconsOfActions.slice() : []
    });
    this.displayedColumns.unshift('select');
    this.displayedColumns = Array.from(new Set(this.displayedColumns));
    this.actionHeader = Array.from(new Set(this.actionHeader));
    this.headersColumns = this.actionHeader.map(elem => elem.icon);
  }

  scrollTop(id) {
    setTimeout(() => {
      document.querySelector(
        '.main-sidenav > .mat-sidenav-content'
      ).scrollTop = id.getBoundingClientRect().top;
    });
  }

  resetCheckList(){
    this.searchControl.setValue('');
    this.checkAlls = {};
    this.selection.clear();
    this.showOtherHeader = false;
  }

  resetValues() {
    if (this.resetCheck) {
      this.searchControl.setValue('');
      this.checkAlls = {};
      this.selection.clear();
      this.showOtherHeader = false;
    }
    if (
      this.dataTable &&
      this.dataTable.expandable &&
      this.expandableConfig &&
      this.expandableConfig.resetValues
    ) {
      this.expandedElement = null;
    }
  }

  // Función que emite la opción del filtro desde un select
  filterRecords(value: string) {
    this.dataTableService.createLocalStorage(this.currentMenu.module, value);
    this.filter.emit(value);
    this.valueFilter = value;
    this.disabledButton = false;
    this.resetValues();
  }

  // Función de busqueda general en la tabla
  filterPredicate() {
    this.dataSource.filterPredicate = (data, filter) => {
      const dataStr = this.dataTable.columns
        .map((column: Column) =>
          column.type === 'string'
            ? column.value(data)
            : column.type === 'boolean' && !column.editable
              ? column.value(data)
                ? 'Activo'
                : 'Inactivo'
              : ''
        )
        .join(' ')
        .toLowerCase();
      return dataStr.includes(filter.trim().toLowerCase());
    };
  }

  search(searchTerm: string, service?: boolean) {
    if (!service) {
      this.dataSource.filter = searchTerm.trim().toLowerCase();
      this.expandedElement = null;
    } else {
      this.searchControl.valueChanges
        .pipe(debounceTime(500))
        .subscribe(response => {
          // if (response.length >= 3) {
            this.valueSearchService.emit(response);
          // }
        });
    }
  }

  emitExpanding(data) {
    this.expandedElement = this.expandedElement === data ? null : data;
    if (this.expandedElement) {
      this.detail.emit(this.expandedElement);
    }else{
      this.closeDetail.emit(true);
    }
  }

  // funcion de la selección de una columna
  onClickViewRecord($event: any, data?: any, type?: any) {
    if (this.dataTable && this.dataTable.expandable) {
      if (this.dataTable.expandingValidation) {
        if (this.dataTable.expandingValidation(data)) {
          this.emitExpanding(data);
        }
      } else {
        if($event.srcElement.localName !== 'svg')
          this.emitExpanding(data);
      }
    } else if (this.dataTable.selectedRow) {
      this.getRowSelected(data);
    } else if (this.dataTable.checkboxIds && data && !type) {
      this.getEmitShipping(data);
    } else if($event.srcElement.localName !== 'svg'){
      this.onClickButtonHeaderTable($event, data, type);
    }
  }

  onClickButtonHeaderTable($event: any, data?: any, type?: any) {
    let ids = this.dataSelect ? this.getIdsTypeDispatch() : null;

    if (this.type === 'storePickupShipping') {
      ids = this.currentConfigType === 'entity' ? `${this.currentConfigType}|${this.currentEntityType}|${this.currentEntityCode}|RT`
        : `${this.currentConfigType}|${this.currentEntityGroup}|RT`;
      type = 'RTconfiguration';
    }

    if (type === 'exceptionalRate') {
      ids = `${this.currentConfigType}|${this.currentEntityType}|${this.currentEntityCode}|RT`
      type = 'RTexceptionalRate';
    }

    this.dataTableService.viewRecord(
      $event,
      data,
      type,
      this.type,
      this.typeEdition, // para zonas
      this.selection.selected[0],
      ids,
      this.currentMenu.link
    );
  }

  onClickButton() {
    this.actionButton.emit(this.currentMenu.link);
  }

  emitDialog() {
    this.showDialog.emit();
  }

  /**
   * TODO: Acciónes de la parte superior de la tabla
   * Cada modulo usa un icono como acción a realizar
   * Tener en cuenta, que cuando se tiene una SUB-TABLA los iconos se pueden repetirce
   * Por ese motivo se agrego un TYPE para que sea más personalizado las acciones y poder distinguir de otras
   * @param icon: string
   * @param dropdown?: any
   * @param type?: any
   */

  onClickIconHeader(icon: string, dropdown?: any, type?: any) {
    if (!dropdown) {
      if (this.selection.selected.length) {
        const paramActionHeader: any = {
          action: icon,
          data: this.selection.selected
        };
        if (type) {
          paramActionHeader.type = type;
        }
        this.iconActionHeader.emit(paramActionHeader);
        if (!this.checkedDialogCheck) {
          this.showOtherHeader = false;
          this.selection.clear();

          if (this.hability) {
            this.onChangeItemValue(true);
          }
        }
      } else {
        this.snackbarService.show('Seleccione al menos un registro', 'warning');
      }
    }
  }

  iconActionTableMultiple(iconInformation) {
    this.iconActionHeader.emit(iconInformation);
  }

  // ... FUnción especifica para zonas *refactoring
  getIdsTypeDispatch = (): string => this.dataSelect.zoneId + '|' + this.dataSelect.name;

  // Función que espera los cambios de toggle en una columna
  updateRecord(name: string, value) {
    const data = this.dataSource.data.map(record => {
      record[name] = value;
      return record;
    });

    this.update.emit({ data, value });
  }
  // Función que emite los datos de una columna editada
  updateRecordInline(name: string, data: any, value: any, index?: number) {
    const id = this.id;
    this.updateInline.emit({ id, name, data, value, index });
  }

  addClas(data: any) {
    if (this.dataTable.classValidation) {
      return this.dataTable.classValidation(data);
    }
  }

  onBlurPassingData(event: any, i) {
    this.updateTable.emit({ element: event, index: i });
  }

  onBlurPassingCheck(event: any, i) {
    this.updateTable.emit({ element: event, index: i });
  }

  /**
   * TODO: Funciones propias de angular material para tableselect
   * @deprecated dataTableService.isSelectedCheckbox
   * Funciones propias de angular material para tableselect Filtro en base al modulo
   */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    let numRows: number;
    if (this.dataTable.hasDisabledCheckBoxItem) {
      numRows =
        (this.dataSource.data &&
          this.dataSource.data.filter(row => !this.dataTable.hasDisabledCheckBoxItem(row)).length) ||
        0;
    } else {
      numRows =
        (this.dataSource.data &&
          this.dataSource.data.length) ||
        0;
    }
    return numSelected === numRows;
  }
  /**
   * TODO: Función permite seleccionar checkAll
   * @deprecated dataTableService.isSelectedCheckbox
   * @emit isMark({ data: null, multiple: true })
   * Función permite seleccionar checkAll de acuerdo a una condición
   */
  onChangeMasterToggle() {
    if (this.dataTable.hasDisabledCheckBoxItem) {
      this.isAllSelected()
        ? this.selection.clear()
        : this.dataSource.data
          .filter(row => !this.dataTable.hasDisabledCheckBoxItem(row))
          .forEach(row => this.selection.select(row));
    } else {
      this.isAllSelected()
        ? this.selection.clear()
        : this.dataSource.data
          .forEach(row => this.selection.select(row));
    }
    this.showActionHeader();
    if (this.selection.selected.length === 0) {
      this.isMark.emit({ data: null, multiple: true, itemsSelected: this.selection.selected });
    }

    this.validateDisabledButton();
  }

  checkboxLabel(row?: any): string {
    return !row ?
      `${this.isAllSelected() ? 'select' : 'deselect'} all` :
      `${this.selection.isSelected(row) ? 'deselect' : 'select'} row`;
  }

  // Función que espera un cambio en el checkboxs para visualizar las acciones en el encabezado
  isCheck(row?: any, index?: any) {
    this.onSelectedChecked(row);
    if (row) {
      this.selection.toggle(row);
    }
    this.showActionHeader(index);

    if (this.selection.isSelected(row) === false) {
      this.isMark.emit({ data: row, multiple: false, itemsSelected: this.selection.selected });
    }

    this.validateDisabledButton();
  }

  validateDisabledButton() {
    if (this.dataTable.isButtonDisabled) {
      if (this.selection.selected.length > 0) {
        this.dataTable.disabled = true;
      } else {
        this.dataTable.disabled = false;
      }
    }
  }

  onChangeItemValue(disabled: any) {
    if (this.itemValue !== undefined) {
      this.itemDisabled = Array.from({ length: this.itemValue.length }).map(o => disabled);
    }
  }

  showActionHeader(index?: any) {
    const numSelected = this.selection.selected.length;

    if (numSelected > 0) {
      this.showOtherHeader = true;

      if (this.hability) {
        if (index !== undefined) {
          this.itemDisabled[index] = false;
        } else {
          this.onChangeItemValue(false);
        }
      }
    } else {
      this.showOtherHeader = false;

      if (this.hability) {
        if (index !== undefined) {
          this.itemDisabled[index] = true;
        } else {
          this.onChangeItemValue(true);
        }
      }
    }
  }

  verifyToggleDisabled(row, i) {
    if (this.itemDisabled[i]) {
      return this.itemDisabled[i];
    } else {
      if (this.dataTable.toggleValidation) {
        return this.dataTable.toggleValidation(row);
      }
    }
  }

  /**
   * TODO: Master seleccionar todos
   * Funcion que da checked a todos los items
   */
  onClickSelection() {
    this.isAllSelected();
    setTimeout(() => {
      this.getEmitShipping(this.selection.selected);
    });
  }

  /**
   * TODO: Emite las columnas seleccionadas
   * @param data: any
   * @emit checkboxItem(data)
   * Emite un evento los items seleccionados
   * variable disabledButton: (poner una descripcion ya que no se tiene claro)
   */
  getEmitShipping(data) {
    this.dataSelect = data;
    this.checkboxItem.emit(data);
    if (!this.dataTable.isButtonDisabled) {
      this.disabledButton = true;
    }
  }

  getRowSelected(data) {
    this.dataSelect = data;
    this.dataSelected.emit(data);
  }

  // Emite la acción de los iconos dentro de la talla
  buttonIcon(item, name) {
    switch (name) {
      case 'view':
      case 'family':
      case 'line':
      case 'section':
      case 'area':
      case 'details':
        this.detail.emit(item);
        break;
      case 'DIVISION':
      case 'AREA':
      case 'DEPARTAMENTO':
      case 'LINEA':
      case 'SECCION':
      case 'FAMILIA':
      case 'SUBFAMILIA':
        this.rowButtonClick.emit({item, name: name});
        break;
      default:
        /** Si hay de un botón en la misma fila */
        item.icon = name;
        item.action = name;
        this.onClickIconColumn.emit(item);
        break;
    }
  }

  /**
   * TODO: Función que emite el evento
   * del icono ubicado en la fila de la sub tabla
   */
  onClickButtonIconRow = (item) => this.actionIconRow.emit(item);
  clearItemsSelected = () => this.selection.clear();

  /**
   * TODO: Accion para deshabilitar checkbox por item [disabled]="boolean"
   * Cada modulo tendrá su propia lógica. Se agregara desde la configuración
   * Con el nombre de la funcion: hasDisabledCheckBoxItem(item: any): boolean
   * @param row: any
   * @returns boolean
   * @deprecated dataTableService.disabledIconHeader
   * Evitemos el uso de dicha función para que no se mas complicado el desarrollo
   */
  hasDisableCheckbox(row: any): boolean {
    if (this.dataTable.hasDisabledCheckBoxItem) {
      return this.dataTable.hasDisabledCheckBoxItem(row, this.selection.selected, this.selection);
    }
    return false;
  }

  isDisableSelect = (value?: any): boolean => this.dataTableService.disbledSelect(value, this.type);

  isDisableMasterCheckbox = (): boolean => this.dataTableService.disabledMasterChecks(this.type)

  /**
   * TODO: Ocultar boton de cabecera [hidden]="boolean"
   * Cada modulo usa una logica distinta defiinir esa logica desde
   * su configuración con la funcion visibleCondition
   * @param typeIcon: IconsOfActions
   * La condición que deberia cumplir para que el icono sea visible es:
   * @returns boolean | <true: Que el icono es visible, false: si el icono no es visible>
   * @deprecated dataTableService.hiddenIconHeader
   * Evitemos el uso de dicha función para que no se mas complicado el desarrollo
   */
  hasHiddenIconHeader(typeIcon: IconsOfActions): boolean {
    const selection: any = this.selection.selected;
    return typeIcon.hasVisibleCondition ?
      !typeIcon.hasVisibleCondition(selection) :
      false;
  }

  disabledInput = (element): boolean =>
    this.dataTable.hasDisabledInput ? this.dataTable.hasDisabledInput(element) : true

  export() {
    this.dataTable.exportAllData ?
      this.loadAllData.emit(true) :
      this.exportData(this.data, false);
  }

  exportAditional() {
    this.loadAditionalAllData.emit(true);
  }

  exportData(dataExport, aditional, id?: any) {
    this.dataTableService.exportData(dataExport, aditional, this.dataTable, id);
  }

  onClickListColumns(): void {
    const dialogRef = this.matDialog.open(DataTableColumnsComponent, {
      width: '400px',
      maxWidth: '90vw',
      data: [...this.dataTable.columns]
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dataTable.columns = [...result];
        this.displayedColumns = result
          .filter((column: any) => column.visible || column.mandatory)
          .map((column: any) => column.name);
      }
    });
  }

  onRefresh() {
    this.dataSource = new MatTableDataSource<Element>([...this.data]);
  }

  sortingDataAccessor(item: any, property: any): string | number {
    if (property === 'deliveryDate') {
      const date = item[property].split('/');
      return new Date(date[2], date[1], date[0]).getTime();
    }
    if (property.includes('.')) {
      return property.split('.').reduce((object, key) => object[key], item);
    }
    return item[property];

  }

  disabledDropDown = (type): boolean => this.dataTableService.disabledDropDown(this.type, type, this.selection.selected);

  ngOnDestroy(): void { }

  onChangeValuesPaginator(limit, offset, stopNextPaginator, limitOptions?, totalRecords?) {
    this.paginatorValues.limit = limit;
    this.paginatorValues.offset = offset;
    this.paginatorValues.limitOptions = limitOptions ? limitOptions : [5, 10, 25, 50];
    this.paginatorValues.totalRecords = totalRecords ? totalRecords : null;
    this.stopNextPaginator = stopNextPaginator;
  }

  onChangePage(event) {
    this.changePage.emit(event);
  }

  changeStatusToDisabled(value) {
    if (this.dataTable && this.dataTable.disabled) {
      this.dataTable.disabled = value;
    }
  }
  /**
   * Renders class object
   * @param item: Colummn
   * @returns any
   */
  renderClassObject(item: Column) {
    let classList: any = {};
    if (item.sortServer) {
      classList = {
        ...{
          'sort-server': true,
          'sort-server-desc': item.sortServerType === SortServerType.DESC,
          'sort-server-asc': item.sortServerType === SortServerType.ASC
        }
      };
    }
    classList[item.class] = true;
    return classList;
  }
  /**
   * Renders class name
   * @param className
   * @returns: string
   */
  renderClassName = (className: any) => className
  /**
   * Determines whether click sort server on
   * @param event: any
   * @param item: Column
   */
  onClickSortServer(index: number) {
    const column = this.dataTable.columns[index];
    if (column.sortServerType) {
      this.dataTable.columns[index].sortServerType = column.sortServerType === SortServerType.ASC ? SortServerType.DESC : SortServerType.ASC;
    } else {
      this.resetColumnsSortServer();
      this.dataTable.columns[index].sortServerType = SortServerType.ASC;
    }
    this.changeSortServer.emit(this.dataTable.columns[index]);
  }
  /**
   * Gets schema by type
   * @param type: string
   * @returns schema by type
   */
  public getSchemaByType = (type: string): any => this.isEntityTable(type,SCHEMAS[type]);
  /**
   * Resets columns sort server
   */
  private resetColumnsSortServer() {
    this.dataTable.columns.map((x: Column) => {
      delete x.sortServerType;
      return x;
    });
  }
  private isEntityTable = (type: string,tableSchema : any) => {
    return type == 'entity' ? (this.isCompanyWithNewConfig ? this.disableColumnTable(tableSchema) : tableSchema) : tableSchema;
  }
  private disableColumnTable = (table : any) => {
    table.columns = table.columns.filter( column => column.name != 'capacity');
    return table;
  }
  get isCompanyWithNewConfig() : boolean {
    let companyCode = JSON.parse(localStorage.getItem(environment.sessionAuth)).user.entity.company.code;
    if(companyCode == REAL_PLAZA_CODE) {
      return true;
    }
    return false;
  }

  showGeneralCheckbox(showCheckbox: boolean){
    this.dataTable.checkboxHeader = showCheckbox;
  }

}
